import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setShippingRate } from "../lib/draft.lib";

export function useSetShippingRate(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return useCallback(
    (shippingRateId: string | null, title?: string | null, amount?: number | null) => {
      setDraft((draft) => (draft ? setShippingRate(draft, shippingRateId, title, amount) : draft));
    },
    [setDraft],
  );
}
